import { Close, Delete, Edit, Input, Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Card,
  FormControlLabel,
  FormGroup,
  Icon,
  Pagination,
  Stack,
  IconButton,
  Switch,
  Tooltip,
} from "@mui/material";
import MDAvatar from "components/MDAvatar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import SkLoading from "components/SkLoading";
import SkModal from "components/SkModal";
import { useMaterialUIController } from "context";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleAlert } from "redux/festures/alertSlice";
import { updateCoupons } from "redux/festures/couponsSlice";
import { getSingleCoupons } from "redux/festures/couponsSlice";
import { getAllCoupons } from "redux/festures/couponsSlice";
import { SkPrice } from "Utils/dateFunc";
import { formattedDateServer } from "Utils/dateFunc";
import Form from "./Form";
import SingleMember from "./SingleMember";
import {
  getAllmemberships,
  getSingleMembership,
  getDisableMember,
} from "redux/festures/membershipSlice";
import DeleteIcon from "@mui/icons-material/Delete";
import { getDeletememberships } from "redux/festures/membershipSlice";
import { getAllglobleMemberships } from "redux/festures/membershipSlice";

// import Form from "./Form";
// import SingleBlog from "./SingleBlog";
const columns = {
  AllMemberships: [
    { Header: "S.No", accessor: "no" },
    { Header: " details", accessor: " details" },
    // { Header: "benefits", accessor: "benefits" },
    { Header: "mrp", accessor: "mrp" },
    {
      Header: "Tax Value",
      accessor: "Tax Value",
    },
    {
      Header: "Discount Percent",
      accessor: "Discount Percent",
    },
    // { Header: "delete", accessor: "delete" },
    { Header: "view", accessor: "view" },
    { Header: "action", accessor: "action" },
    // { Header: "delete", accessor: "delete" },
  ],
};

function createAllBrands(isAdmin) {
  return [
    { Header: "S.No", accessor: "no" },
    { Header: " details", accessor: " details" },
    // { Header: "benefits", accessor: "benefits" },
    { Header: "After Tax Value", accessor: "mrp" },

    // isAdmin?.permissions?.all
    //   ? {
    //       Header: "delete",
    //       accessor: "delete",
    //     }
    //   : isAdmin?.permissions?.membership?.includes("DISABLE") && {
    //       Header: "delete",
    //       accessor: "delete",
    //     },
    isAdmin?.permissions?.all
      ? {
          Header: "view",
          accessor: "view",
        }
      : isAdmin?.permissions?.membership?.includes("VIEWS") && {
          Header: "view",
          accessor: "view",
        },
    isAdmin?.permissions?.all
      ? {
          Header: "action",
          accessor: "action",
        }
      : isAdmin?.permissions?.membership?.includes("UPDATE") && {
          Header: "action",
          accessor: "action",
        },
  ].filter(Boolean);
}
const Membership = () => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const admin = localStorage.getItem("admin_id");
  const dispatch = useDispatch();
  const [rowsData, setRowsData] = useState([]);

  const { isAdmin } = useSelector((data) => ({ ...data?.admin }));

  const resultAllBrands = createAllBrands(isAdmin);
  const { Loading, memberships, singlemembership } = useSelector((data) => ({
    ...data?.isMembership,
  }));
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenView, setIsOpenView] = useState(false);
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  console.log(memberships,"swdfghjkdfghj")

  useEffect(() => {
    dispatch(getAllmemberships(`${process.env.REACT_APP_API}/getAllMembership`));
  }, []);

  useEffect(() => {
    if (memberships && memberships?.length > 0) {
      const temprows =
        memberships &&
        memberships?.at(0) &&
        memberships?.map((value, index) => ({
          no: (
            <MDTypography key={index} sx={{ fontSize: 12, fontWeight: "medium" }} variant="text">
              {index + 1}
            </MDTypography>
          ),
          " details": (
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 0.5,
              }}
            >
              <MDBox sx={{ height: 40, width: 40 }}>
                <img
                  src={`${process.env.REACT_APP_URI}/${value?.icon}`}
                  alt={"img"}
                 onError={(e) => {
                    (e.onError = null),
                      (e.target.src = require("../../assets/images/no123.jpeg"));
                  }}
                  style={{ width: "100%", height: "100%", borderRadius: "50%" }}
                />
              </MDBox>
              <MDBox
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: 1,
                  flexDirection: "column",
                }}
              >
                <MDTypography
                  display="block"
                  variant="button"
                  fontWeight="medium"
                  ml={1}
                  lineHeight={1}
                >
                  Title:{value?.title || "N/A"}
                </MDTypography>
                <MDTypography
                  display="block"
                  variant="button"
                  fontWeight="medium"
                  ml={1}
                  lineHeight={1}
                  style={{
                    maxWidth: "250px",
                    lineHeight: "20px",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 2,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  TaxId: {value?.taxId || "N/A"}
                </MDTypography>
              </MDBox>
            </MDBox>
          ),
          benefits: (
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",

                gap: 1,
                flexDirection: "column",
              }}
            >
              {value?.benefits?.slice(0, 3).map((ele, i) => (
                <MDTypography
                  key={i}
                  display="block"
                  variant="button"
                  fontWeight="medium"
                  // ml={1}
                  lineHeight={1}
                  style={{
                    maxWidth: "250px",
                    lineHeight: "20px",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 2,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {ele || "N/A"}
                </MDTypography>
              ))}
            </MDBox>
          ),
          mrp: (
            <MDBox flexDirection="column">
              <MDTypography fontSize={12.5}>{SkPrice(value?.afterTaxValue)}</MDTypography>
              {/* <MDTypography fontSize={12.5}>Qty : {value?.couponQuantity || "N/A"}</MDTypography> */}
            </MDBox>
          ),
          "Tax Value": (
            <MDBox flexDirection="column">
              {/* <MDTypography fontSize={12.5}>max discount :</MDTypography> */}
              <MDTypography fontSize={12.5}>
                {" "}
                After Tax Value :{value?.afterTaxValue || "N/A"}
              </MDTypography>
              <MDTypography fontSize={12.5}>
                {" "}
                Before Tax Value:{value?.beforeTaxValue || "N/A"}
              </MDTypography>
            </MDBox>
          ),
          "Discount Percent": (
            <MDBox flexDirection="column">
              <MDTypography fontSize={12.5}>{value?.priceDiscount}%</MDTypography>
              {/* <MDTypography fontSize={12.5}>Qty : {value?.couponQuantity || "N/A"}</MDTypography> */}
            </MDBox>
          ),
          view: (
            <IconButton
              aria-label="action_edit"
              onClick={() => {
                setIsOpenView(true);
                dispatch(getSingleMembership(value));
              }}
            >
              <Visibility
                sx={({ palette: { dark, white, info } }) => ({
                  color: darkMode ? info.main : dark.main,
                })}
              />
            </IconButton>
          ),

          delete: (
            <Tooltip title={value?.disable ? "move to Active" : "delete"}>
              <IconButton
                aria-label="action_edit"
                // disabled={value?.disable}
                onClick={() => {
                  dispatch(
                    getDisableMember({
                      url: `${process.env.REACT_APP_API}/disableMembership/${value?._id}`,
                    })
                  ).then((data) => {
                    // console.log(data,"ghvhvhvhbvh")
                    dispatch(
                      handleAlert({
                        isOpen: true,
                        type: `${data?.payload?.success ? "success" : "error"}`,
                        msg: data?.payload?.message,
                      })
                    );
                    if (data?.payload?.success) {
                      dispatch(
                        getAllglobleMemberships(`${process.env.REACT_APP_API}/getAllMembership`)
                      );
                    }
                  });
                }}
              >
                {value?.disable ? (
                  <Input
                    sx={({ palette: { dark, white, info } }) => ({
                      color: darkMode ? info.main : dark.main,
                    })}
                  />
                ) : (
                  <Delete
                    sx={({ palette: { dark, white, info } }) => ({
                      color: darkMode ? info.main : dark.main,
                    })}
                  />
                )}
              </IconButton>
            </Tooltip>
          ),
          // "disable": (
          //   <Switch
          //     value={value?.disable}
          //     checked={value?.disable}
          //     color={"info"}
          //     onChange={(e) => {
          //       //   handleSwitchControl(value?._id);
          //       //   setIsSwitch(!isSwitch);
          //       dispatch(
          // getDisableMember({
          //   url: `${process.env.REACT_APP_API}/disableMembership/${value?._id}`,
          // })
          //       ).then((data) => {
          //         dispatch(
          //           handleAlert({
          //             isOpen: true,
          //             type: `${data?.payload?.success ? "success" : "error"}`,
          //             msg: data?.payload?.message,
          //           })
          //         );
          //         if (data?.payload?.success) {
          //           dispatch(getAllmemberships(`${process.env.REACT_APP_API}/getAllMembership`));
          //         }
          //       });
          //     }}
          //     inputProps={{ "aria-label": "controlled" }}
          //   />
          // ),

          action: (
            <>
              <IconButton
                aria-label="action_edit"
                onClick={() => {
                  setIsOpen(true);
                  setIsOpenUpdate(true);
                  // console.log(value?._id);
                  dispatch(getSingleMembership(value));
                }}
              >
                <Edit
                  sx={({ palette: { dark, white, info } }) => ({
                    color: darkMode ? info.main : dark.main,
                  })}
                />
              </IconButton>
            </>
          ),
          // url: `${process.env.REACT_APP_APII}/deleteMembership/${value?._id}/${admin}`
          // "delete": (
          //   <>
          //     <IconButton
          //       aria-label="delete"
          //       onClick={(e) => {
          //         //   handleSwitchControl(value?._id);
          //         //   setIsSwitch(!isSwitch);
          //         dispatch(
          //           getDeletememberships(
          //             `${process.env.REACT_APP_APII}/deleteMembership/${value?._id}/${admin}`,
          //           )
          //         ).then((data) => {
          //           dispatch(
          //             handleAlert({
          //               isOpen: true,
          //               type: `${data?.payload?.success ? "success" : "error"}`,
          //               msg: data?.payload?.message,
          //             })
          //           );
          //           if (data?.payload?.success) {
          //             dispatch(
          //               getAllmemberships(
          //                 `${process.env.REACT_APP_APII}/getAllMembershipByAdmin/${admin}`
          //               )
          //             );
          //           }
          //         });
          //       }}
          //     >
          //       <DeleteIcon
          //         sx={({ palette: { dark, white, info } }) => ({
          //           color: darkMode ? info.main : dark.main,
          //         })}
          //       />
          //     </IconButton>
          //   </>
          // ),
        }));
      setRowsData(temprows);
    } else {
      setRowsData(["", " "]);
    }
  }, [memberships]);
  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox mb={2} />
        <MDBox py={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <MDTypography variant="h6" color="white">
                Membership&apos;s Table{" "}
              </MDTypography>
              {/* <MDButton
              disabled={Loading}
                variant="gradient"
                color="dark"
                sx={({ palette: { dark, white, info } }) => ({
                  color: white.main,
                  backgroundColor: dark.main,
                  "&:hover": {
                    color: white.main,
                    backgroundColor: dark.main,
                  },
                })}
                onClick={() => {
                  setIsOpen(true);
                  setIsOpenUpdate(false);
                }}
              >
                <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                &nbsp; Create Membership
              </MDButton> */}
            </MDBox>
            <MDBox py={3}>
              {Loading ? (
                <SkLoading />
              ) : memberships && memberships?.length > 0 ? (
                <DataTable
                  table={{
                    columns: resultAllBrands,
                    rows: rowsData,
                  }}
                  isSorted={false}
                  entriesPerPage={false}
                  isPages={memberships && memberships?.length}
                  noEndBorder
                  canSearch={false}
                  showTotalEntries={false}
                  pagination={false}
                  isPagination={false}
                />
              ) : (
                <MDBox
                  // key={index}
                  display="flex"
                  justifyContent="center"
                  gap={2}
                  alignItems="center"
                  // width={"100%"}
                >
                  <MDTypography variant="h6">No Data Found !</MDTypography>
                </MDBox>
              )}
            </MDBox>
          </Card>
        </MDBox>
        <Footer />
      </DashboardLayout>
      <SkModal
        show={isOpen}
        unShow={setIsOpen}
        width={{ sx: "100%", md: "65%", xl: "65%", sm: "100%" }}
        height={"90vh"}
        padding={3}
        overflowY={true}
      >
        <Form isOpenUpdate={isOpenUpdate} setIsOpenUpdate={setIsOpenUpdate} setIsOpen={setIsOpen} />
      </SkModal>
      <SkModal
        show={isOpenView}
        unShow={setIsOpenView}
        width={{ sx: "100%", md: "65%", xl: "65%", sm: "100%" }}
        height={"90vh"}
        padding={3}
        overflowY={true}
        disableScrollbar={true}
      >
        <SingleMember />
      </SkModal>
    </>
  );
};

export default Membership;
